import React from "react";
import {
  FaArrowRight,
  FaRegClock,
  FaRegCalendarAlt,
  FaBookOpen,
} from "react-icons/fa";
import { getAllPosts } from "../data/blogPosts";
import "./Blog.css";

// Anasayfada en alta yakın yer alan blog tanıtım bölümü.
function BlogSection({ onOpenPost, onOpenList }) {
  const posts = getAllPosts().slice(0, 3);

  if (posts.length === 0) return null;

  return (
    <section className="blog-section" id="blog">
      <div className="container">
        <div className="blog-section-head">
          <span className="eyebrow">Blog & Rehberler</span>
          <h2 className="section-title">Almanya Eğitim Rehberleri</h2>
          <p className="section-subtitle">
            Sıfır Almanca ile ücretsiz üniversite eğitimi, başvuru ve vize
            süreçleri hakkında merak ettiğiniz her şey uzman ekibimizin
            kaleminden.
          </p>
        </div>

        <div className="blog-section-cards">
          {posts.map((post) => (
            <a
              key={post.slug}
              className="blog-card"
              href={`/blog/${post.slug}`}
              onClick={(e) => {
                e.preventDefault();
                onOpenPost(post.slug);
              }}
            >
              <div className="blog-card-img">
                <img src={post.cover} alt={post.coverAlt} loading="lazy" />
                <span className="blog-card-cat">{post.category}</span>
              </div>
              <div className="blog-card-body">
                <div className="blog-card-meta">
                  <span>
                    <FaRegCalendarAlt /> {post.dateReadable}
                  </span>
                  <span>
                    <FaRegClock /> {post.readingTime} dk
                  </span>
                </div>
                <h2>{post.title}</h2>
                <p>{post.excerpt}</p>
                <span className="blog-card-readmore">
                  Yazıyı Oku <FaArrowRight />
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="blog-section-foot">
          <a
            className="cta-button primary"
            href="/blog"
            onClick={(e) => {
              e.preventDefault();
              onOpenList();
            }}
          >
            <FaBookOpen /> Tüm Yazıları Gör
          </a>
        </div>
      </div>
    </section>
  );
}

export default BlogSection;
